import authentication from 'services/authentication';
import type { Route } from 'contracts';

import type { ContainerSize } from './container.store';

interface ContainerMetadata {
  withSidebar: boolean;
  size: ContainerSize;
}

const getContainerMetadata = (route: Route): ContainerMetadata => {
  return {
    withSidebar: authentication.isAuthenticated() && !(route?.meta?.hideSidebar ?? false),
    size: route?.meta?.containerSize ?? 'default',
  };
};

export type { ContainerMetadata };
export { getContainerMetadata };
